/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Admin_Impersonation_BannerInputs */

const en_mobile_admin_impersonation_banner = /** @type {(inputs: Mobile_Admin_Impersonation_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are impersonating another user`)
};

const es_mobile_admin_impersonation_banner = /** @type {(inputs: Mobile_Admin_Impersonation_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estás impersonando a otro usuario`)
};

/**
* | output |
* | --- |
* | "You are impersonating another user" |
*
* @param {Mobile_Admin_Impersonation_BannerInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_admin_impersonation_banner = /** @type {((inputs?: Mobile_Admin_Impersonation_BannerInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Admin_Impersonation_BannerInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_admin_impersonation_banner(inputs)
	return en_mobile_admin_impersonation_banner(inputs)
});